/** Paths where an automatic reload would interrupt a flow — show a banner instead. */
export function shouldDeferServiceWorkerReload() {
  const path = window.location.pathname;
  return path.startsWith('/checkout') || path.startsWith('/admin');
}

export function isStandaloneDisplayMode() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

/** Tell the waiting worker to activate immediately. */
export function activateWaitingServiceWorker(registration) {
  const waiting = registration?.waiting;
  if (!waiting) return false;
  waiting.postMessage({ type: 'SKIP_WAITING' });
  return true;
}

let reloadScheduled = false;

/** Reload once when a new service worker takes control. */
export function reloadForServiceWorkerUpdate() {
  if (reloadScheduled) return;
  reloadScheduled = true;
  window.location.reload();
}

export const SW_UPDATE_PENDING_EVENT = 'saloni-sw-update-pending';

export function notifyServiceWorkerUpdatePending() {
  window.dispatchEvent(new CustomEvent(SW_UPDATE_PENDING_EVENT));
}
